// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { SINGLE_CHOICE_UI_TYPE } from './../../../types/next/blocks/singleChoiceBlock'
import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'
import { fileIdSchema } from './ids.zod'

export const singleChoiceUiTypeSchema = z.nativeEnum(SINGLE_CHOICE_UI_TYPE)

const sharedSettingsSchema = z.object({
  label: z.string().optional()
})

export const singleChoiceValueSchema = z
  .union([z.string(), z.undefined()])
  .nullable()

const imageChoiceUiSubtypeSchema = z.any()

const buttonChoiceLayoutTypeSchema = z.any()

const iconChoiceSchema = z.any()

const imageChoiceSchema = z.any()

const iSingleChoiceBaseBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.SINGLE_CHOICE),
  settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
    z.object({
      uiType: singleChoiceUiTypeSchema,
      imageType: z.union([z.never(), imageChoiceUiSubtypeSchema]).optional(),
      buttonType: z.union([z.never(), buttonChoiceLayoutTypeSchema]).optional(),
      choices: z.array(z.union([iconChoiceSchema, imageChoiceSchema])),
      choicesFileId: z.union([z.never(), fileIdSchema]).optional()
    })
  )
})

export const buttonSingleChoiceBlockSchema =
  iSingleChoiceBaseBlockSchema.extend({
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        uiType: z.literal(SINGLE_CHOICE_UI_TYPE.BUTTON),
        imageType: z.never().optional(),
        buttonType: buttonChoiceLayoutTypeSchema.optional(),
        choices: z.array(iconChoiceSchema),
        choicesFileId: z.never().optional()
      })
    )
  })

export const radioSingleChoiceBlockSchema = iSingleChoiceBaseBlockSchema.extend(
  {
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        uiType: z.literal(SINGLE_CHOICE_UI_TYPE.RADIO),
        imageType: z.never().optional(),
        buttonType: z.never().optional(),
        choices: z.array(iconChoiceSchema),
        choicesFileId: z.never().optional()
      })
    )
  }
)

export const dropdownSingleChoiceBlockSchema =
  iSingleChoiceBaseBlockSchema.extend({
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        uiType: z.literal(SINGLE_CHOICE_UI_TYPE.DROPDOWN),
        imageType: z.never().optional(),
        buttonType: z.never().optional(),
        choices: z.array(iconChoiceSchema),
        choicesFileId: z.union([z.never(), fileIdSchema]).optional()
      })
    )
  })

export const imageSingleChoiceBlockSchema = iSingleChoiceBaseBlockSchema.extend(
  {
    settings: blockBaseSettingsSchema.and(sharedSettingsSchema).and(
      z.object({
        uiType: z.literal(SINGLE_CHOICE_UI_TYPE.IMAGE),
        imageType: imageChoiceUiSubtypeSchema,
        buttonType: z.never().optional(),
        choices: z.array(z.union([iconChoiceSchema, imageChoiceSchema])),
        choicesFileId: z.never().optional()
      })
    )
  }
)

export const singleChoiceBlockSchema = z.union([
  buttonSingleChoiceBlockSchema,
  radioSingleChoiceBlockSchema,
  dropdownSingleChoiceBlockSchema,
  imageSingleChoiceBlockSchema
])
